import {
  type SpaceSelectDataQuery,
  useSpaceSelectDataQuery,
} from '@/__generated__/types';

export type SpaceNode = SpaceSelectDataQuery['spaceTree'][number];

export const useSpaces = () => {
  const { data, loading } = useSpaceSelectDataQuery({
    fetchPolicy: 'cache-first',
  });

  return { spaces: data?.spaceTree ?? [], isLoading: loading };
};
